import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * Eventbrite logo icon component
 */
export const EventbriteLogo: FC<Props> = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.8841 15.4232L12.2491 10.2635C12.1391 10.1786 12.2541 10.009 12.3741 10.0788L14.9641 11.5259C16.1391 12.1847 17.6241 11.8004 18.3341 10.6627C19.0841 9.46008 18.6891 7.87824 17.4591 7.16967L13.6591 4.97904C13.5391 4.90918 13.6291 4.72455 13.7591 4.77944L15.5041 5.47804C15.5091 5.47804 15.5491 5.49302 15.5641 5.498C15.7491 5.56287 15.9491 5.59781 16.1541 5.59781C17.0991 5.59781 17.8791 4.8493 17.9441 3.96108C18.0291 2.80339 17.1491 2 16.0941 2H8.02414C6.98914 2 6.11414 2.84331 6.12914 3.87625C6.13414 4.42515 6.38414 4.91417 6.76914 5.2485C7.05914 5.50299 8.03913 6.28143 8.50413 6.65568C8.58913 6.72056 8.53914 6.85528 8.43414 6.85528H6.81914C5.11914 6.86527 3.74414 8.24251 3.74414 9.93912C3.74414 10.7974 4.09414 11.5708 4.66414 12.1348L14.0191 21.007C14.6791 21.6207 15.5691 22 16.5441 22C18.5941 22 20.2541 20.3433 20.2541 18.2974C20.2491 17.1397 19.7191 16.1018 18.8841 15.4232Z"
      fill="currentColor"
    />
  </svg>
);
